module.exports = new __parcel__URL__("alexis-dupre.17a23524.jpeg").toString();